import React, { useContext, useMemo } from "react"
import { observer } from "mobx-react-lite"
import { CloudDownload, Eye, EyeSlash } from "react-bootstrap-icons"
import { useParams } from "react-router-dom"
import { CampaignContext } from "../../../../../contexts/CampaignContext"
import { format } from "date-fns"
import Button from "../../../../Shared/Button"
import TimelineHeaderUi from "../../../../Shared/TimelineParts/TimelineHeaderUi"
import axiosService from "../../../../../utils/AxiosService"
import { toastError, toastSuccess } from "../../../../FormComponents/Toasts"
import { useReadOnly } from "../../../../../contexts/ReadOnlyContext"

export default observer(function TimelineHeader({
  activeTab,
  onTabChange,
}) {
  const { id } = useParams()
  const readOnly = useReadOnly()
  const { campaign, campaignScenarios } = useContext(CampaignContext)

  const primaryScenario = campaignScenarios[0]
  const primaryScenarioId = primaryScenario?.id

  const exportScenario = () => {
    if (!primaryScenarioId) return
    window.open(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/export`)
  }

  const toggleTimelineVisible = () => {
    if (!primaryScenarioId) return

    axiosService
      .patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}`, {
        campaign_scenario: { timeline_visible: !primaryScenario.timeline_visible },
      })
      .then(updatedCampaignScenario => {
        primaryScenario.timeline_visible = !!updatedCampaignScenario.timeline_visible
        toastSuccess(primaryScenario.timeline_visible ? 'Timeline visible for advertiser' : 'Timeline is hidden from advertiser')
      })
      .catch(({ data: { error } }) => toastError(error))
  }

  const campaignDateRange = useMemo(() => {
    if (!campaign?.start_date || !campaign?.end_date) return null

    const startDate = new Date(campaign.start_date)
    const endDate = new Date(campaign.end_date)
    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return null

    return `(${format(startDate, 'dd.MM.yyyy')} - ${format(endDate, 'dd.MM.yyyy')})`
  }, [campaign?.start_date, campaign?.end_date])

  return (
    <TimelineHeaderUi
      campaign={campaign}
      dateRange={campaignDateRange}
      activeTab={activeTab}
      onTabChange={onTabChange}
      actions={
        primaryScenarioId ? (
          <>
            {!readOnly && (
              <Button
                variant="secondary"
                onClick={toggleTimelineVisible}
                className="flex gap-2 items-center"
                title={primaryScenario.timeline_visible ? 'Hide timeline from advertiser' : 'Show timeline to advertiser'}
              >
                {primaryScenario.timeline_visible ? <Eye className='font-bold text-sm text-rb-green' /> : <EyeSlash className='font-bold text-sm text-gray-400' />}
                <span className='font-semibold'>Visibility</span>
              </Button>
            )}
            <Button
              variant="secondary"
              onClick={exportScenario}
              className="flex gap-2 items-center"
            >
              <CloudDownload className='font-bold text-sm' />
              <span className='font-semibold'>Export</span>
            </Button>
          </>
        ) : null
      }
    />
  )
})
